import React, { createContext, useContext, useEffect, useState } from 'react';
import { createServiceLayer } from '../services';
import { Provider } from 'react-redux';
const ServiceAPIsContext = createContext(null);
const useServiceLayer = ({ platformAPI, initialState, log }) => {
    const [serviceLayer, setServiceLayer] = useState(() => createServiceLayer({
        platformAPI,
        initialState,
        log,
    }));
    // Support dynamically replacing the service layer sate on a dispatched custom event.
    // Used by E2E testing to verify app state from specific state shapes.
    useEffect(() => {
        const e2eReplaceServiceLayerHandler = (e) => {
            console.info('Received "e2e:replaceStore" event with payload', e.detail);
            const state = JSON.parse(e.detail);
            console.info('Updating service layer with state', state);
            setServiceLayer(createServiceLayer({
                platformAPI,
                initialState: state,
                log,
            }));
        };
        window.addEventListener('e2e:replaceStore', e2eReplaceServiceLayerHandler);
        return () => window.removeEventListener('e2e:replaceStore', e2eReplaceServiceLayerHandler);
    }, []);
    return serviceLayer;
};
export const ServiceLayerProvider = ({ children, ...rest }) => {
    const { serviceAPIs, store } = useServiceLayer(rest);
    return (React.createElement(Provider, { store: store },
        React.createElement(ServiceAPIsContext.Provider, { value: serviceAPIs }, children)));
};
export const useServices = () => {
    const services = useContext(ServiceAPIsContext);
    if (!services)
        throw new Error('IllegalState: Services must be provided via ServiceProvider before being used');
    return services;
};
//# sourceMappingURL=ServiceProvider.js.map